<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        block
        color="success"
        v-on="on"
      >
        Create Job Description
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      :loading="loading"
      color="green"
      title="Job Description"
      text="Create Job Description"
      class="mb-0"
    > 
      <form v-if="!loading">
        <v-container v-if="dialog">
          <v-row>
            <v-col cols="12">
              <v-textarea
                v-model="value"
                v-validate="'required|max:1000'"
                :rows="5"
                :error-messages="errors.collect('value')"
                data-vv-name="value"     
                data-vv-as="description"           
                label="Description"
              />
            </v-col>            
            <v-col cols="12">
              <v-autocomplete
                v-model="tagIds"
                :items="tags"          
                label="Tags"
                placeholder="Job Description Tags"
                item-text="name"
                item-value="id"
                hide-no-data
                hide-selected
                multiple
                chips
                deletable-chips
                clearable
              />
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    data () {
      return {
        progressing: false,
        loading: false,
        dialog: false,
        value: '',
        tagIds: [],
        tags: [],
      }
    },
    watch: {
      dialog: function (value) {
        if (value) {
          this.resetForm()
          this.loadTags()
        }
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll().then((result) => {
          if (!result) return 

          this.progressing = true

          this.$api.jobDescriptions().create({ value: this.value })
            .then(response => {
              if (this.tagIds.length <= 0) {
                this.$snack({ message: 'Added new job description' })
                this.$emit('created')

                this.dialog = false
                this.progressing = false

                return
              }

              this.$api.jobDescriptionTags().update(response.data.id, this.tagIds)
                .then(response => {
                  this.$snack({ message: 'Added new job description' })
                  this.$emit('created')

                  this.dialog = false
                })
                .catch(() => {})
                .then(() => {
                  this.progressing = false
                })
            })
        })
      },
      loadTags () {
        this.loading = true
      
        this.$api.tags().list()
          .then(response => {
            this.tags = response.data

            this.loading = false
          })
      },
      resetForm () {
        this.value = ''
        this.tagIds.splice(0, this.tagIds.length)
        this.$validator.reset()
      },
    },
  }
</script>
